import { useEffect, useState } from 'react';
import {
  DEFAULT_WEIGHT_UNIT,
  WEIGHT_UNIT_STORAGE_KEY,
  resolveWeightUnit
} from '../utils/weightUnits';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

export function getCachedWeightUnit() {
  try {
    return resolveWeightUnit(localStorage.getItem(WEIGHT_UNIT_STORAGE_KEY));
  } catch (error) {
    return DEFAULT_WEIGHT_UNIT;
  }
}

export function setCachedWeightUnit(unit) {
  const resolved = resolveWeightUnit(unit);
  try {
    localStorage.setItem(WEIGHT_UNIT_STORAGE_KEY, resolved);
  } catch (error) {
    // ignore quota / private-mode failures
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('weightUnitChanged', { detail: resolved }));
  }
  return resolved;
}

export function useWeightUnit() {
  const [weightUnit, setWeightUnit] = useState(getCachedWeightUnit);

  useEffect(() => {
    const onChange = (event) => {
      setWeightUnit(resolveWeightUnit(event.detail));
    };
    window.addEventListener('weightUnitChanged', onChange);
    return () => window.removeEventListener('weightUnitChanged', onChange);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return undefined;

    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${API_URL}/profile`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (!res.ok) return;
        const data = await res.json();
        const next = resolveWeightUnit(data.preferences?.weightUnit);
        if (!cancelled) {
          setCachedWeightUnit(next);
          setWeightUnit(next);
        }
      } catch (error) {
        // stay on the cached default
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return weightUnit;
}
